/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsRecommendedProducts = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsRecommendedProducts = $.extend(this, window.PXUTheme.getSectionData($section));

    // Look for an element with class 'product-recommendations'
    const $productRecommendations = $section.find('.product-recommendations');

    // Selectors
    const productID = $productRecommendations.data('product-id');
    const limit = $productRecommendations.data('limit');
    const sectionID = $productRecommendations.data('section-id');
    const recommendationsEnabled = $productRecommendations.data('enabled') === true || $productRecommendations.data('enabled') === 'true';
    const hasRenderedProducts = $productRecommendations.find('.product__grid-item, .gallery-cell.thumbnail').length > 0;

    // If showing custom collection we do not want to build request url
    if (this.show_custom_collection) {
      this.initializeRenderedRecommendations($section, $productRecommendations);
      return;
    }

    if (hasRenderedProducts) {
      this.initializeRenderedRecommendations($section, $productRecommendations);

      if (!recommendationsEnabled) {
        return;
      }
    }

    if (!recommendationsEnabled) {
      return;
    }

    this.showSkeletons($productRecommendations);

    // Build request URL
    const shopURL = $productRecommendations.data('base-url');
    const requestUrl = `${shopURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

    $.ajax({
      type: 'GET',
      url: requestUrl,
      success: function(data) {

        let $recommendedProductsElement = $(data).find('.product-recommendations').html();
        if (!$recommendedProductsElement || $.trim($recommendedProductsElement).length === 0) {
          window.PXUTheme.jsRecommendedProducts.hideSkeletons($productRecommendations);
          return;
        }

        // Insert product list into the product recommendations container
        $productRecommendations.html($recommendedProductsElement);

        window.PXUTheme.jsRecommendedProducts.initializeRenderedRecommendations($section, $productRecommendations);
      },
      error: function() {
        window.PXUTheme.jsRecommendedProducts.hideSkeletons($productRecommendations);
      }
    });
  },
  initializeRenderedRecommendations: function($section, $productRecommendations) {
    this.hideSkeletons($productRecommendations);
    window.PXUTheme.jsProduct.relatedProducts();
    this.refreshRecommendationImages($productRecommendations);

    // Initialize shopify payment buttons
    if (Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    // Converting the currencies
    if (window.PXUTheme.currencyConverter) {
      window.PXUTheme.currencyConverter.convertCurrencies();
    }
  },
  showSkeletons: function($productRecommendations) {
    const container = $productRecommendations && $productRecommendations[0];
    if (!container || container.querySelector('.related-products-skeletons')) return;

    const limit = Number($productRecommendations.data('limit')) || 4;
    const productsPer = Number($productRecommendations.data('products-per')) || 3;
    const layout = $productRecommendations.data('layout') || 'grid';
    const count = Math.min(limit, Math.max(productsPer, 2));
    const cards = [];

    for (let i = 0; i < count; i++) {
      cards.push(`
        <div class="related-products-skeleton__card">
          <div class="related-products-skeleton__image skeleton-shimmer"></div>
          <div class="related-products-skeleton__text">
            <span class="related-products-skeleton__line skeleton-shimmer"></span>
            <span class="related-products-skeleton__line related-products-skeleton__line--short skeleton-shimmer"></span>
          </div>
        </div>
      `);
    }

    const skeletonMarkup = `
      <div class="related-products-skeletons related-products-skeletons--${layout}" aria-hidden="true">
        <div class="related-products-skeletons__track" style="--skeleton-columns:${Math.max(productsPer, 2)};">
          ${cards.join('')}
        </div>
      </div>
    `;

    container.insertAdjacentHTML('beforeend', skeletonMarkup);
    container.classList.add('is-loading');
  },
  hideSkeletons: function($productRecommendations) {
    const container = $productRecommendations && $productRecommendations[0];
    if (!container) return;

    const skeletons = container.querySelector('.related-products-skeletons');
    if (skeletons) {
      skeletons.remove();
    }

    container.classList.remove('is-loading');
  },
  refreshRecommendationImages: function($productRecommendations) {
    const container = $productRecommendations && $productRecommendations[0];
    if (!container) return;

    const lazyImages = container.querySelectorAll('img.lazyload');

    if (window.lazySizes && window.lazySizes.loader) {
      if (typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
      }

      if (typeof window.lazySizes.loader.unveil === 'function') {
        lazyImages.forEach(function(image, index) {
          if (index < 6) {
            window.lazySizes.loader.unveil(image);
          }
        });
      }
    }
  },
  setupRecommendedVideoPlayer: function($section) {
    const videosInRecommendedProducts = $section.find('[data-product-recommendations-container] [data-html5-video] video, [data-product-recommendations-container] [data-youtube-video]').get();

    // Only run Plyr.setup if videosInRecommendedProducts exists
    if (videosInRecommendedProducts.length > 0) {
      videosInRecommendedProductsPlayer = Plyr.setup(videosInRecommendedProducts, {
        controls: videoControls,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      if (videoPlayers !== null) {
        var combinedArray = videoPlayers.concat(videosInRecommendedProductsPlayer);
        videoPlayers = combinedArray;
      } else {
        videoPlayers = videosInRecommendedProductsPlayer;
      }
    }

    window.PXUTheme.jsVideo.setupListeners();
  },
  showCustomCollection: function($section) {
    const $recommendedProductsElement = $section.find('.product-recommendations').html();

    const $productRecommendationsContainer = $('.product-recommendations');
    $productRecommendationsContainer.html($recommendedProductsElement);

    this.initializeRenderedRecommendations($section, $productRecommendationsContainer);
  },
  unload: function($section) {
  }
}

/******/ })()
;
